module.exports = __webpack_public_path__ + "static/media/DarwinHeaderWhite.20e0e752.svg";